import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Text } from "recharts";
import { PieChartData } from "../../../constants/common";

interface CustomPieChartProps {
  data: PieChartData[];
  isLabel?: boolean;
  innerRadius: number;
}

const COLORS = ["#403f68", "#7170A3", "#535277", "#73728d"];

const CustomLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  index,
  data,
}: {
  cx: number;
  cy: number;
  midAngle: number;
  innerRadius: number;
  outerRadius: number;
  index: number;
  data: PieChartData[];
}) => {
  const RADIAN = Math.PI / 180;
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5; // Adjust label position here
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <>
      <Text
        x={x}
        y={y - 8}
        fill="white"
        textAnchor="middle"
        dominantBaseline="central"
        fontSize={12}
      >
        {`${data[index].value}`}
      </Text>
      <Text
        x={x}
        y={y + 10}
        fill="white"
        textAnchor="middle"
        dominantBaseline="central"
        fontSize={11}
      >
        {data[index].name}
      </Text>
    </>
  );
};

const CustomPieChart = ({
  data,
  isLabel = true,
  innerRadius,
}: CustomPieChartProps) => {
  return (
    <ResponsiveContainer width="100%" height={350}>
      <PieChart>
        <Pie
          data={data}
          cx="50%"
          cy="50%"
          innerRadius={innerRadius}
          outerRadius={105}
          dataKey="value"
          labelLine={false}
          label={(props) => isLabel && <CustomLabel {...props} data={data} />}
        >
          {data?.map((_, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
      </PieChart>
    </ResponsiveContainer>
  );
};

export default React.memo(CustomPieChart);
